module.exports = __webpack_public_path__ + "static/media/cdmx.28207eee.jpg";